export default "__VITE_ASSET__BIBmPwZd__"